import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoriesPreview() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                热门赛事分类
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">
                覆盖全球各大体育赛事，满足您的所有需求
              </p>
            </div>
            <Link
              to="/category/football"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
            >
              查看全部分类
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.slice(0, 6).map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group block rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 no-underline"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/80 text-background-50">
                        <i className={`${category.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                      </div>
                      <h3 className="font-semibold text-background-50 text-base">
                        {category.name}
                      </h3>
                    </div>
                    <p className="text-xs text-background-200/80">
                      {category.count.toLocaleString()}+ 场赛事
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}